import React from "react";
import SecuritySettings from "./SecuritySettings/SecuritySettings";
import AlertSettings from "./AlertSettings/AlertSettings";
import "./GlobalSetting.scss";
import SubHeader from "../SubHeader";
import AccessibleTabs from "../AccessibleTabs/AccessibleTabs";

const tabs = [
  { id: "securitySetting", label: "Security", Component: SecuritySettings },
  { id: "alert", label: "Alert", Component: AlertSettings },
];

const GlobalSetting = () => {
  return (
    <div className="globalSettingWrapper main_ele_wrapper">
      <SubHeader heading="Global Settings" />

      <AccessibleTabs
        tabs={tabs}
        defaultActive="securitySetting"
        panelWrapperClass="gsdeetails_wrapper"
        panelClassMap={{
          securitySetting: "securitySettingMedia",
          alert: "alertSettingMedias",
        }}
      />
    </div>
  );
};

export default GlobalSetting;
